"use client";

import React from "react";

interface LoaderProps {
  fullscreen?: boolean; // optional prop to show full-page loader
  size?: number; // spinner size
  color?: string; // spinner color
}

const Loader: React.FC<LoaderProps> = ({
  fullscreen = false,
  size = 40,
  color = "#2563eb", // Tailwind blue-600
}) => {
  const spinner = (
    <div
      className="animate-spin rounded-full border-4 border-t-transparent"
      style={{
        width: size,
        height: size,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
  );

  if (fullscreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/70 z-50">
        {spinner}
      </div>
    );
  }

  return <div className="flex items-center justify-center">{spinner}</div>;
};

export default Loader;
